export default __webpack_public_path__ + "static/media/gameplay.733d8652.png";